export default theme => ({
  prayerScreen: {
    position: 'relative',
    zIndex: '10',
    overflow: 'hidden',
  }
})